/* eslint-disable */
/* ***********************************************************
* A short word on how to use this automagically generated file.
* We're often asked in the ignite gitter channel how to connect
* to a to a third party api, so we thought we'd demonstrate - but
* you should know you can use sagas for other flow control too.
*
* Other points:
*  - You'll need to add this saga to sagas/index.js
*  - This template uses the api declared in sagas/index.js, so
*    you'll need to define a constant in that file.
*************************************************************/

import { call, put, fork, select, take } from 'redux-saga/effects'
import PostPeopleActions from '../Redux/PostPeopleRedux'
// import { PostPeopleSelectors } from '../Redux/PostPeopleRedux'
import { UserPopularSelectors } from '../Redux/UserPopularRedux'
const getUserFromState = (state) => state.userPopular.response
const getUserFollow = (state) => state.getFollow.data
export function* getPostPeople(api, action) {
  try {
    var start = Date.now( )
   // yield take(['USER_POPULAR_SUCCESS'])
    const { data: { limit = 0, isSearch = false, user = '', userId = '', isFollower = false } } = action
    let users
    if (isSearch == true) {
      users = yield call(api.searchUser, {limit, user})
    } else {
      users = yield call(api.getPopularUsers, limit)
    }
    // const userFollows =  yield call(api.getFollowings, userId, 500)

    var chunksize = 20
    var chunks = []

    users.data.data.forEach((item) => {
      if (!chunks.length || chunks[chunks.length - 1].length == chunksize)
        chunks.push([])
      chunks[chunks.length - 1].push(item)
    })

    for (const item of chunks) {
      var result
      if (isSearch == true) {
        result = item.map(a => a.UserId)
      }

      const responsePost = yield call(api.getPostsPeople, {
        userIds: isSearch ? result.toString() : item.toString(),
        limit: 4 // 4 posts is enough
      })

      const { data: { data } } = responsePost

/*
      // UserIsFollowing is now returned by the API
      responsePost.data.data.forEach((element, i) => {
        userFollows.data.data.map((item, index) => {
          if (item.Username === element.Username) {
            responsePost.data.data[i].UserIsFollowing = true
          }
        })
      })
*/

      if (responsePost.ok) {
        responsePost.isSearch = isSearch
        responsePost.start = start
        yield put(PostPeopleActions.postPeopleSuccess(responsePost))
      } else {
        yield put(PostPeopleActions.postPeopleFailure())
      }
    }
  } catch (e) {
    console.tron.display({
      name: `getPostPeopleAsyn fail`,
      preview: ``,
      value: {
        state: e
      }
    })
  }

}
// export const getPostPeople = function* getPostPeople(api, action) {

//   yield fork(getPostPeopleAsyn, api, action)


// }

export function* getUsers(api, action) {
  try {
    const fullState = yield select() // the entire app state
    state = fullState.postPeople
    let usersChanges
    // var start = Date.now( )
    console.tron.display({name: `getUsers`, preview: `api call`, value: { action: action } })
    const { search } = action
    let response
    if (search)
      response = yield call(api.searchUser, {limit : 200, user: search})
    else
      response = yield call(api.getPopularUsers)
    console.tron.display({name: `getUsers`, preview: `api call`, value: { action: action, search: search, response: response } })

    if (response.ok) {
      usersChanges = {
        fetching: false,
        data: response.data.data,
        timeStamp: Date.now()
      }
    } else {
      usersChanges = {
        fetching: false,
        error: 'failed',
        timeStamp: Date.now()
      }
    }
    stateChanges = {
      users: Object.assign({}, state.users, usersChanges)
    }
    console.tron.display({name: `getUsers`, preview: `calling postPeopleComplete`, value: { stateChanges: stateChanges } })
    yield put(PostPeopleActions.postPeopleComplete(stateChanges))
  } catch (error) {
    console.tron.display({name: `getUsers`, preview: `fail`, value: { error: error, errorMessage: error.message } })
  }
}

export function* getUserPosts(api, action) {
  try {
    console.tron.display({name: `getUserPosts`, preview: `start`, value: { action: action } })
    const fullState = yield select() // the entire app state
    state = fullState.postPeople
    let postChanges
    const { userIds } = action
    const userIdsString = userIds.join(',')
    const response = yield call(api.getPostsPeople, { userIds: userIdsString, limit: 4 })
    console.tron.display({name: `getUserPosts`, preview: `api call response`, value: { action: action, userIds: userIds, userIdsString: userIdsString, response: response } })

    if (response.ok) {
      postChanges = {
        fetching: false,
        data: response.data.data,
        timeStamp: Date.now()
      }
    } else {
      postChanges = {
        fetching: false,
        error: 'failed',
        timeStamp: Date()
      }
    }
    stateChanges = {
      usersAndPosts: Object.assign({}, state.usersAndPosts, postChanges)
    }
    console.tron.display({name: `getUserPosts`, preview: `calling postPeopleComplete`, value: { stateChanges: stateChanges } })
    yield put(PostPeopleActions.postPeopleComplete(stateChanges))
  } catch (error) {
    console.tron.display({name: `getUserPosts`, preview: `fail`, value: { error: error, errorMessage: error.message } })
  }
}
